module.exports = __webpack_public_path__ + "img/icon_customer_garbage_can.svg";